var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.19 15.192v9.23c0 .645-.518 1.168-1.157 1.168h-1.96a.116.116 0 01-.115-.117v-9.23c0-.645.518-1.168 1.157-1.168h1.96c.063 0 .115.053.115.117zM8.743 1.225v10.803a.116.116 0 01-.116.117H6.656c-.64 0-1.157-.523-1.157-1.167V.174c0-.064.051-.116.116-.116h1.971c.64 0 1.157.522 1.157 1.167zM8.743 20.616v8.304c0 .645-.518 1.167-1.157 1.167H5.615a.116.116 0 01-.116-.116v-8.304c0-.645.518-1.168 1.157-1.168h1.971c.065 0 .116.053.116.117zM3.235 23.472v5.448c0 .645-.518 1.167-1.157 1.167H.116A.116.116 0 010 29.971v-5.448c0-.645.518-1.168 1.157-1.168h1.962c.064 0 .116.053.116.117zM14.19 5.727v4.732a.116.116 0 01-.116.117h-1.96a1.162 1.162 0 01-1.156-1.167V4.676c0-.064.052-.117.116-.117h1.96c.638 0 1.156.523 1.156 1.168zM3.235 1.225v5.449a.116.116 0 01-.116.116H1.157A1.162 1.162 0 010 5.624V.174C0 .11.052.058.116.058h1.962c.639 0 1.157.522 1.157 1.167zM29.762 29.975v-7.758c0-.743-.292-1.456-.813-1.981l-2.836-2.861a2.764 2.764 0 00-1.962-.82h-7.689a.116.116 0 00-.115.117v7.758c0 .743.292 1.455.813 1.98l2.835 2.861c.52.526 1.226.82 1.963.82h7.688a.116.116 0 00.116-.116z",
    fill: "#2A342A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.762.117v7.758c0 .743-.292 1.456-.813 1.98l-2.836 2.862c-.52.525-1.226.82-1.962.82h-7.689a.116.116 0 01-.115-.117V5.662c0-.743.292-1.455.813-1.98L19.995.82A2.762 2.762 0 0121.958 0h7.688c.064 0 .116.053.116.117z",
    fill: "url(#logo_svg__paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__paint0_linear",
    x1: 29.762,
    y1: 0,
    x2: 16.225,
    y2: 13.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })))));
}

export default SvgLogo;